













































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Copy from "@/components/copy.vue";
import {
  GetCurrentUserData,
  PostPhoneCode,
  PostChangePhone,
  PostChangePassword
} from "@/request/account";
import { validatePhoneNumber } from "@/utils/validator";
import { countDownTime } from "@/utils/count-down-time";
import Header from "../../components/common-header.vue";
import LeftNav from "../../components/left-nav.vue";
@Component({
  components: {
    Header,
    LeftNav,
    Copy
  }
})
export default class AccountManage extends Vue {
  private user: any = {};
  private ifShowChangePhone: boolean = false;
  private waitTime: any = 60;
  private newPhone: any = "";
  private phoneCode: any = "";
  private ifShowChangeEmail: boolean = false;
  private newEmail: any = "";
  private emailCode: any = "";
  private ifShowChangePassword: boolean = false;
  private newPassword: any = "";
  private renewPassword: any = "";
  /**
   * @description 获取用户信息
   */
  private fetchUserData() {
    GetCurrentUserData(this).then((data: any) => {
      this.user = data;
    });
  }
  /**
   * @description 开始修改手机号码
   */
  private startChangePhone() {
    this.ifShowChangePhone = true;
    this.phoneCode = "";
    this.newPhone = "";
  }
  /**
   * @description 获得验证码
   */
  private getCode() {
    const { valide, message } = validatePhoneNumber(this.newPhone);
    if (!valide) {
      this.$message.error(message);
    } else {
      PostPhoneCode(this, this.newPhone).then(() => {
        this.$message.success("发送成功");
        this.waitTime = 60;
        localStorage.setItem("waitTime", this.waitTime.toString());
        countDownTime(this, this.waitTime, "waitTime");
      });
    }
  }
  /**
   * @description 确认修改手机
   */
  private confirmChangePhone() {
    const params: any = {
      新手机号: this.newPhone,
      验证码: this.phoneCode
    };
    PostChangePhone(this, params)
      .then(() => {
        this.phoneCode = "";
        this.newPhone = "";
        this.ifShowChangePhone = false;
        this.fetchUserData();
        this.$message.success("修改成功");
      })
      .catch(() => {
        this.phoneCode = "";
      });
  }
  /**
   * @description 开始修改邮箱
   */
  private startChangeEmail() {
    this.ifShowChangeEmail = true;
    this.emailCode = "";
    this.newEmail = "";
  }
  /**
   * @description 获得邮箱验证码
   */
  private getEmailCode() {
    PostPhoneCode(this, this.user["手机号"]).then(() => {
      this.$message.success("发送成功");
      this.waitTime = 60;
      localStorage.setItem("waitTime", this.waitTime.toString());
      countDownTime(this, this.waitTime, "waitTime");
    });
  }
  /**
   * @description 确认绑定邮箱
   */
  private confirmChangeEmail() {
    // const params: any = {
    //   新手机号: this.newPhone,
    //   验证码: this.phoneCode
    // };
    // PostChangePhone(this, params)
    //   .then(() => {
    //     this.phoneCode = "";
    //     this.newPhone = "";
    //     this.ifShowChangePhone = false;
    //     this.fetchUserData();
    //     this.$message.success("修改成功");
    //   })
    //   .catch(() => {
    //     this.phoneCode = "";
    //   });
  }
  /**
   * @description 开始修改密码
   */
  private startChangePassword() {
    this.ifShowChangePassword = true;
    this.newPassword = "";
    this.renewPassword = "";
  }
  /**
   * @description 确定修改密码
   */
  private confirmChangePassword() {
    if (this.newPassword !== this.renewPassword) {
      this.$message.error("两次输入的密码不一致，请重新输入");
      this.newPassword = "";
      this.renewPassword = "";
      return;
    }
    const params: any = {
      新密码: this.newPassword
    };
    PostChangePassword(this, params).then(() => {
      this.$message.success("修改成功");
      this.newPassword = "";
      this.renewPassword = "";
      this.ifShowChangePassword = false;
    });
  }

  /**
   * @description 初始化
   */
  private mounted() {
    this.waitTime = Number(localStorage.getItem("waitTime") || "0");
    if (this.waitTime !== 0) {
      countDownTime(this, this.waitTime, "waitTime");
    }
    this.fetchUserData();
  }
}
